<template>
    <v-list>
        <v-list-item-group
                v-model="active"
        >
            <div class="row m-5" style="position: absolute; z-index:2; top:-0.3rem; left: 0">
                <div class="text-left">
                    <a href="#" @click="toggleMobileMenu()" class="btn btn-xs btn-icon btn-light btn-hover-danger">
                        <i class="ki ki-close icon-xs text-muted"></i>
                    </a>
                </div>
            </div>
            <div class="d-flex justify-content-end bg-white-o-50 ">
                <v-list-item link
                             class=""
                             color="primary"
                             @click="toggleMobileMenu()"
                >
                    <div class=" w-100 d-flex justify-content-center">
                        <img
                                alt="Logo"
                                :src="layoutConfig('self.logo.default')"
                                class="logo-default max-h-40px"
                        />
                    </div>


                </v-list-item>
            </div>

            <router-link
                    to="/home"
                    v-slot="{ href, navigate, isActive, isExactActive }">
                <a :href="homeLink()">
                    <v-list-item link color="primary">
                        <v-list-item-icon class="mr-2">
                            <v-icon color="#6cdb72">mdi-home</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="mr-2 text-white"> خانه</v-list-item-title>
                    </v-list-item>
                </a>
            </router-link>

            <router-link to="/dashboard">
                <v-list-item link color="primary">
                    <v-list-item-icon class="mr-2">
                        <v-icon color="#6cdb72">widgets</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="mr-2 text-white"> داشبورد</v-list-item-title>
                </v-list-item>
            </router-link>

            <router-link
                    v-slot="{ href, navigate, isActive, isExactActive }" to="profile">
                <a href='https://core.terminalads.com/#/profile/my-profile' target="_blank">
                    <v-list-item link color="primary">
                        <v-list-item-icon class="mr-2">
                            <v-icon color="#6cdb72">mdi-account</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="mr-2 text-white"> پروفایل</v-list-item-title>
                    </v-list-item>
                </a>
            </router-link>

            <router-link
                    v-slot="{ href, navigate, isActive, isExactActive }" to="profile">
                <a href='https://core.terminalads.com/#/tickets/create' target="_blank">
                    <v-list-item link color="primary">
                        <v-list-item-icon class="mr-2">
                            <v-icon color="#6cdb72">mdi-ticket</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="mr-2 text-white"> ثبت تیکت</v-list-item-title>
                    </v-list-item>
                </a>
            </router-link>

            <router-link
                    v-for="item in items"
                    :to="`/${item.slug}`"
                    v-slot="{ href, navigate, isActive, isExactActive }">
                <div v-if="!item.children" class="w-100">
                    <a :href="href === '#/' ? '' : href" class="w-100">
                        <v-list-item link>
                            <v-list-item-icon class="mr-2">
                                <v-icon v-if="item.icon" color="#fff">{{ item.icon }}</v-icon>
                                <v-icon v-else color="#fff">mdi-circle-small</v-icon>
                            </v-list-item-icon>

                            <v-list-item-title class="mr-2 text-white">{{ item.name }}</v-list-item-title>
                        </v-list-item>
                    </a>
                </div>


                <v-list-group
                        v-else
                >
                    <template v-slot:activator>
                        <v-list-item-icon class="mr-2">
                            <v-icon v-if="item.icon" color="#fff">{{ item.icon }}</v-icon>
                            <v-icon v-else color="#fff">mdi-circle-small</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title class="mr-2 text-white">{{ item.name }}</v-list-item-title>
                    </template>


                    <v-list-item
                            v-for="ch1 in item.children"
                            no-action
                            sub-group
                    >

                        <router-link

                                :to="`/${ch1.slug}`"
                                v-slot="{ href, navigate, isActive, isExactActive }">


                            <div v-if="!ch1.children" class="w-100">
                                <a :href="href === '#/' ? '' : href" class="w-100">
                                    <v-list-item link>
                                        <v-list-item-icon class="mr-2">
                                            <v-icon v-if="item.icon" color="#fff">{{ ch1.icon }}</v-icon>
                                            <v-icon v-else color="#fff">mdi-circle-small</v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-title class="mr-2 text-white">{{ ch1.name }}</v-list-item-title>
                                    </v-list-item>
                                </a>
                            </div>

                            <v-list-group
                                    v-else
                            >
                                <template v-slot:activator>
                                    <v-list-item-icon class="mr-2">
                                        <v-icon v-if="ch1.icon" color="#fff">{{ ch1.icon }}</v-icon>
                                        <v-icon v-else color="#fff">mdi-circle-small</v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-title class="mr-2 text-white">{{ ch1.name }}</v-list-item-title>
                                </template>


                                <v-list-group
                                        no-action
                                        sub-group
                                >

                                    <router-link
                                            v-for="ch2 in ch1.children"
                                            :to="`/${ch2.slug?ch2.slug:'#'}`"
                                            v-slot="{ href, navigate, isActive, isExactActive }">


                                        <div v-if="!ch2.children" class="w-100">
                                            <a :href="href === '#/' ? '' : href" class="w-100">
                                                <v-list-item link>
                                                    <v-list-item-icon class="mr-2">
                                                        <v-icon v-if="ch2.icon">{{ item.icon }}</v-icon>
                                                        <v-icon v-else>mdi-circle-small</v-icon>
                                                    </v-list-item-icon>

                                                    <v-list-item-title class="mr-2}">{{ ch2.name }}</v-list-item-title>
                                                </v-list-item>
                                            </a>
                                        </div>

                                    </router-link>

                                </v-list-group>

                            </v-list-group>

                        </router-link>
                    </v-list-item>

                </v-list-group>

            </router-link>


        </v-list-item-group>
    </v-list>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "AsideMenu",
    data() {
        return {
            active: 0,
            admins: [
                ['Management', 'mdi-account-multiple-outline'],
                ['Settings', 'mdi-cog-outline'],
            ],
            cruds: [
                ['Create', 'mdi-plus-outline'],
                ['Read', 'mdi-file-outline'],
                ['Update', 'mdi-update'],
                ['Delete', 'mdi-delete'],
            ],
        }
    },
    computed: {
        ...mapGetters({
            items: 'menu/items'
        }),
        ...mapGetters(["layoutConfig", "getClasses"]),
    },
    methods: {
        homeLink() {
            return process.env.VUE_APP_HOME_URL;
        }
    }
};
</script>

<style scoped>
.mdi-chevron-down {
    color: #fff !important;
}
</style>
